import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  ContClientsSection,
  TitleClients,
  ClientsGrid,
  ClientItem,
  ClientLogo,
} from './CoreBancarioClients.styles';

import AQGray from "../../assets/images/ourClients/aq-gray.png";
import AQColor from "../../assets/images/ourClients/aq-hover.png";
import EnpagosColor from '../../assets/images/ourClients/enpagos-color.webp';
import EnpagosGray from '../../assets/images/ourClients/enpagos-gray.webp';
import FortradeGray from "../../assets/images/CoreBankingModulesImages/ourClients/Fortrade.png";
import FortradeColor from "../../assets/images/CoreBankingModulesImages/ourClients/Fortrade.png";
import KluColor from '../../assets/images/ourClients/klu-color.png';
import KluGray from '../../assets/images/ourClients/klu-gray.png';
import PinpeoColor from '../../assets/images/ourClients/pinpeo-color.webp';
import PinpeoGray from '../../assets/images/ourClients/pinpeo-gray.webp';
import SodaCapitalColor from '../../assets/images/ourClients/sodacapital-color.png';
import SodaCapitalGray from '../../assets/images/ourClients/sodacapital-gray.png';

const ItemClient = ({ logoGray, logoColor, name }) => {
  const [currentLogo, setCurrentLogo] = useState(logoGray);

  return (
    <ClientLogo
      src={currentLogo}
      alt={name}
      onMouseOver={() => setCurrentLogo(logoColor)}
      onMouseOut={() => setCurrentLogo(logoGray)}
    />
  );
};

export const CoreBancarioClients = () => {
  const { t } = useTranslation();

  const clients = [
    { id: 1, logoGray: AQGray, logoColor: AQColor, name: 'AQ' },
    { id: 2, logoGray: KluGray, logoColor: KluColor, name: 'Klu' },
    { id: 3, logoGray: FortradeGray, logoColor: FortradeColor, name: 'Fortrade' },
    { id: 4, logoGray: EnpagosGray, logoColor: EnpagosColor, name: 'Enpagos' },
    { id: 5, logoGray: PinpeoGray, logoColor: PinpeoColor, name: 'Pinpeo' },
    { id: 6, logoGray: SodaCapitalGray, logoColor: SodaCapitalColor, name: 'SodaCapital' },
  ];

  return (
    <ContClientsSection>
      <TitleClients>
        {t('Nuestros Clientes')}
      </TitleClients>
      <ClientsGrid>
        {clients.map((client) => (
          <ClientItem key={client.id}>
            <ItemClient 
              logoGray={client.logoGray} 
              logoColor={client.logoColor} 
              name={client.name} 
            />
          </ClientItem>
        ))}
      </ClientsGrid>
    </ContClientsSection>
  );
};
